const originalInitialize = fabric.ActiveSelection.prototype.initialize;
fabric.ActiveSelection.prototype.initialize = function () {
    const returnValue = originalInitialize.apply(this, arguments);
    this.updateLockStatus();
    return returnValue;
};

const originalAdd = fabric.ActiveSelection.prototype.add;
fabric.ActiveSelection.prototype.add = function () {
    const returnValue = originalAdd.apply(this, arguments);
    this.updateLockStatus();
    return returnValue;
};

const originalAddWithUpdate = fabric.ActiveSelection.prototype.addWithUpdate;
fabric.ActiveSelection.prototype.addWithUpdate = function () {
    const returnValue = originalAddWithUpdate.apply(this, arguments);
    this.updateLockStatus();
    return returnValue;
};

const originalRemove = fabric.ActiveSelection.prototype.remove;
fabric.ActiveSelection.prototype.remove = function () {
    const returnValue = originalRemove.apply(this, arguments);
    this.updateLockStatus();
    return returnValue;
};

const originalRemoveWithUpdate = fabric.ActiveSelection.prototype.removeWithUpdate;
fabric.ActiveSelection.prototype.removeWithUpdate = function () {
    const returnValue = originalRemoveWithUpdate.apply(this, arguments);
    this.updateLockStatus();
    return returnValue;
};

fabric.ActiveSelection.prototype.updateLockStatus = function () {
    // If any object in the selection is locked, lock the selection too!
    const shouldLock = this.getObjects().some((object) => object.locked || object.lockedByGroup);
    if (this.evented !== !shouldLock) {
        this.set('evented', !shouldLock);
        this.set('selectable', !shouldLock);
        this.set('hasControls', !shouldLock);
    }
};
